import { useMutation, useQuery } from "./urqlHooks";

const CREATE_OBLIGATION = `mutation CREATE_OBLIGATION($input: ObligationDocumentInput!, $isDte: Boolean!, $companyId: String!) {
  createObligationDocument(input: $input, isDte: $isDte, companyId: $companyId) {
    id,
    documentType
  }
}`;

export const CreateObligation = () => {
    const [result, executeMutation] = useMutation(CREATE_OBLIGATION)
    const { data, fetching, error } = result;
    return { data, fetching, error, executeMutation }
};

const CREATE_MASSIVE_OBLIGATIONS = `mutation CREATE_MASSIVE_OBLIGATION($input: [ObligationDocumentInput!]!, $companyId: String!) {
  createObligationsMassive(input: $input, companyId: $companyId) {
    status,
    rowNumber,
    errorMsg
  }
}`;

export const CreateObligationsMassive = () => {
  const [result, executeMutation] = useMutation(CREATE_MASSIVE_OBLIGATIONS)
  const { data, fetching, error } = result;
  return { data, fetching, error, executeMutation }
};

const GET_OBLIGATIONS = `query GET_OBLIGATIONS($input: ObligationsInput, $companyId: String!) {
  getObligations(input: $input, companyId: $companyId) {
    _id
    familyLabel
    family
    familyKey
    typeLabel
    type
    typeKey
    key
    isReceived
    allowedToggle
  }
}`;

export const GetObligations = (input, pause = false) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_OBLIGATIONS,
    // La query declara $companyId: String!, así que debe viajar también como variable (no solo dentro de input).
    variables: input ? { input, companyId: input.companyId } : {},
    // Pause query if explicitly paused, input is null, or there is no companyId (variable obligatoria)
    pause: pause || input === null || input === undefined || !input.companyId,
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const FIND_EXISTING_OBLIGATION = `query FIND_EXISTING_OBLIGATION($companyId: String!, $type: String!, $period: String!) {
  findExistingObligation(companyId: $companyId, type: $type, period: $period) {
    id
    _id
    documentType
    amount
    currencyType
    documentDate
    name
    description
    meta {
      ... on ObligationMeta {
        type
        typeLabel
        family
        familyLabel
        period
        description
        detail {
          description
          item
          name
          quantity
          unit_price
          total_price
        }
        amount
        currency
        remaining
        originalAmount
        isPaid
        isReceived
        issuerId
        issuerName
        receiverId
        receiverName
        creditDocumentId
        parentCreditId
        documentDate
        date
        number
        documentId
        exchange {
          originalAmount
          originalCurrency
          localAmount
          localCurrency
          exchangeRate
          exchangeDate
        }
      }
    }
  }
}`;

export const FindExistingObligation = (companyId, type, period, pause = true) => {
  const [result, reexecuteQuery] = useQuery({
    query: FIND_EXISTING_OBLIGATION,
    variables: { companyId, type, period },
    pause: pause || !companyId || !type || !period,
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};